/**
 * Footer of the content column: sober, with a top rule.
 * Reminds the user of local persistence (browser only).
 */
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mx-auto hidden w-full max-w-[1180px] px-4 pb-10 md:block md:px-8 print:hidden">
      <div className="filete-editorial flex flex-col gap-1 pt-5 sm:flex-row sm:items-baseline sm:justify-between">
        <p className="text-[12px] leading-4 text-tinta-2">
          {t('common.footer.brandLine')}
        </p>
        <p className="text-[12px] leading-4 text-tinta-3">
          <Link to="/privacy" className="underline decoration-linea-fuerte underline-offset-4 hover:text-tinta">
            {t('legal.nav.privacy')}
          </Link>
          {' · '}
          <Link to="/terms" className="underline decoration-linea-fuerte underline-offset-4 hover:text-tinta">
            {t('legal.nav.terms')}
          </Link>
          {' · '}
          {t('common.footer.localStorageNote')}
        </p>
      </div>
    </footer>
  );
}
